export const TERMS_AND_CONDITIONS = "https://www.well-b.biz/terms-and-conditions";
